import { Button, Alert } from 'antd'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'
import React from 'react'
import { userManager, signinCallbackPath, signoutCallbackPath } from './utils'
import { getLoginError, getSecurityInfo } from '../core/selectors'
import * as actions from '../core/actions'
import jwtDecode from 'jwt-decode'
import { finalizeLogout, getMetaConfig } from 'utils'
import { memoizeWith } from 'ramda'
const oidcTokenName = getMetaConfig('oidcTokenName', 'id_token')

// const oauthServerPort = 8088

const isJwtCurrent = memoizeWith(
  i => i,
  rawJwt => {
    if (rawJwt == null) return false

    try {
      const decoded = jwtDecode(rawJwt)
      if (new Date().getTime() > decoded.exp * 1000) return false
      return true
    } catch (e) {
      console.log('cannot decode jwt', rawJwt, e)
      return false
    }
  }
)

class SigninCallBack extends React.Component {
  componentDidMount() {
    userManager
      .signinRedirectCallback()
      .then(this.props.onSuccess)
      .catch(this.props.onError)
  }

  render() {
    return <div style={{ display: 'none' }} />
  }
}

class SignoutCallBack extends React.Component {
  componentDidMount() {
    userManager
      .signoutRedirectCallback()
      .then(this.props.onSuccess)
      .catch(this.props.onError)
  }

  render() {
    return <div style={{ display: 'none' }} />
  }
}

class OidcAuthenticated extends React.Component {
  state = {
    user: null,
    // errorMessage: null,
  }

  componentDidMount() {
    if (userManager != null)
      userManager.getUser().then(user => this.setState({ user }))
  }

  handleLogin() {
    userManager.signinRedirect()
  }

  render() {
    const { securityInfo, convertIdToken, loginError } = this.props
    const rawJwt = securityInfo != null ? securityInfo.jwt : null
    const jwtCurrent = isJwtCurrent(rawJwt)
    const errorMessage =
      loginError == null
        ? null
        : loginError.errorMsg != null
        ? loginError.errorMsg
        : loginError.message != null
        ? loginError.message
        : 'Unknown error, check logs'

    return (
      <React.Fragment>
        <Route
          path={signinCallbackPath}
          render={() => (
            <SigninCallBack
              onSuccess={u => {
                console.log('sign in call back got ', u)
                convertIdToken(u[oidcTokenName])
                this.setState({ user: u })
              }}
              onError={err => console.log('error: ', err)}
            />
          )}
        />
        <Route
          path={signoutCallbackPath}
          render={() => (
            <SignoutCallBack
              onSuccess={() => {
                finalizeLogout(true)
              }}
              onError={err => console.log('error: ', err)}
            />
          )}
        />
        {userManager != null && (this.state.user == null || !jwtCurrent) ? (
          <div
            style={{
              width: '100vw',
              height: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Button
                style={{ marginBottom: '10px' }}
                // loading={convertingToken}
                onClick={this.handleLogin}
                type="primary"
              >
                Login with Open Connect ID
              </Button>

              {errorMessage && (
                <Alert
                  style={{ marginBottom: '5px', maxWidth: '70vw' }}
                  message={errorMessage}
                  type="error"
                />
              )}
            </div>
          </div>
        ) : (
          this.props.children
        )}
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  securityInfo: getSecurityInfo(state),
  loginError: getLoginError(state),
})

const mapDispatchToProps = dispatch => ({
  convertIdToken: jwt => dispatch(actions.convertIdToken(jwt)),
})

export default connect(mapStateToProps, mapDispatchToProps)(OidcAuthenticated)
